import {
  Directive,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

import { MediaQueryService } from 'app/services';

@Directive({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[amIfMobile]'
})
export class IfMobileDirective {
  constructor(
    private _templateRef: TemplateRef<any>,
    private _viewContainer: ViewContainerRef,
    private _mediaQueryService: MediaQueryService,
  ) {
    if (_mediaQueryService.isMobile.matches) {
      this._viewContainer.createEmbeddedView(this._templateRef);
    }
  }
}
